import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {NotFoundComponent} from 'app/not-found/not-found.component';
import {ProcessErrorComponent} from 'app/process-error/process-error.component';
import {ProcessErrorActivateGuard} from 'app/process-error/process-error-activate.guard';
import {AdminSigninComponent} from 'app/admin/admin-signin/admin-signin.component';
import {AdminSignoutComponent} from 'app/admin/admin-signout/admin-signout.component';
import {AdminAccountResultComponent} from 'app/admin/admin-account-result/admin-account-result.component';
import {AdminAccountResultActivateGuard} from 'app/admin/admin-account-result/admin-account-result-activate.guard';
import {PreloadSelectedModulesList} from 'app/preload-selected-modules-list';


const appRoutes: Routes = [
  {path: '', loadChildren: 'app/admin/admin.module#AdminModule', data: {preload: false}},
  {path: 'yonetim-giris-yap', component: AdminSigninComponent},
  {path: 'yonetim-guvenli-cikis', component: AdminSignoutComponent},
  {
    path: 'yonetim-bilgilerim-sonuc', component: AdminAccountResultComponent,
    canActivate: [AdminAccountResultActivateGuard],
  },
  {
    path: 'islem-hata', component: ProcessErrorComponent,
    canActivate: [ProcessErrorActivateGuard]
  },
  {path: 'bulunamadi', component: NotFoundComponent},
  {path: '**', redirectTo: '/bulunamadi', pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, {preloadingStrategy: PreloadSelectedModulesList})],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/app-routing/app-routing.module.ts